{
    "EvaluationsData": [
        {
            "Team": "Agent",
            "Agent": "Oscar Donan",
            "Evaluations": 29,
            "AvgScore": 50.21,
            "Variance": 18.01
        },
        {
            "Team": "Agent",
            "Agent": "Parimala Admin",
            "Evaluations": 40,
            "AvgScore": 18.25,
            "Variance": -13.95
        },
        {
            "Team": "CV CXONE",
            "Agent": "Ankit Bhasin",
            "Evaluations": 30,
            "AvgScore": 60.5,
            "Variance": 10.23
        },
        {
            "Team": "CV CXONE",
            "Agent": "Ashish Kumbhar",
            "Evaluations": 15,
            "AvgScore": 40.05,
            "Variance": -10.22
        },
        {
            "Team": "CV ACD TEAM",
            "Agent": "Avihoo Cohen",
            "Evaluations": 18,
            "AvgScore": 17.3,
            "Variance": 0.27
        },
        {
            "Team": "CV Dashboard Team",
            "Agent": "Cade Rasmussen",
            "Evaluations": 10,
            "AvgScore": 9.20,
            "Variance": -19.65
        },
        {
            "Team": "CV Dashboard Team",
            "Agent": "Colton Visser",
            "Evaluations": 23,
            "AvgScore": 48.50,
            "Variance": 19.65
        },
        {
            "Team": "Calibration",
            "Agent": "Alexander Melera",
            "Evaluations": 50,
            "AvgScore": 44.6,
            "Variance": 6.33
        },
        {
            "Team": "Calibration",
            "Agent": "Alex",
            "Evaluations": 24,
            "AvgScore": 46,
            "Variance": 7.73
        },
        {
            "Team": "Calibration",
            "Agent": "Andrew Hicks",
            "Evaluations": 34,
            "AvgScore": 24.2,
            "Variance": -14.07
        },
        {
            "Team": "CEA Team",
            "Agent": "Ashadeepa Debnath",
            "Evaluations": 30,
            "AvgScore": 12.7,
            "Variance": 0.63
        },
        {
            "Team": "CV Integrations",
            "Agent": "Ashish Agent",
            "Evaluations": 15,
            "AvgScore": 16.5,
            "Variance": -13.18
        },
        {
            "Team": "CV Integrations",
            "Agent": "Parimal Agent",
            "Evaluations": 22,
            "AvgScore": 56.05,
            "Variance": 26.37
        },
        {
            "Team": "CV Integrations",
            "Agent": "Ben",
            "Evaluations": 10,
            "AvgScore": 16.5,
            "Variance": -13.18
        }
    ],
    "ChannelsData": [
        {
            "TeamID": "83faeb0b-692e-4f28-a27e-f491fd172f11",
            "Team": "BN_Agent Team",
            "AgentID": "11ef65e9-0ee3-56e0-881b-0242ac110004",
            "Agent": "bharathi agent",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 60.57
                },
                {
                    "Channel": "EMAIL",
                    "AvgScore": null
                }
            ],
            "TeamAvgScore": 60.57
        },
        {
            "TeamID": "83faeb0b-692e-4f28-a27e-f491fd172f11",
            "Team": "BN_Agent Team",
            "AgentID": "11efb95a-e3a1-9f30-92bd-0242ac110002",
            "Agent": "bharathi agent 2",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": null
                }
            ],
            "TeamAvgScore": 60.57
        },
        {
            "TeamID": "02cd5b81-c0a5-41fd-b0d1-4abecea28308",
            "Team": "CVD Team",
            "AgentID": "11ee1604-50a4-01f0-938d-0242ac110005",
            "Agent": "DanielCurrent1 AgentActive1",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 21.0
                },
                {
                    "Channel": "CHAT",
                    "AvgScore": 2.67
                }
            ],
            "TeamAvgScore": 11.84
        },
        {
            "TeamID": "c0ef6aef-0f35-11ed-b815-064e4e02d9cf",
            "Team": "DefaultTeam",
            "AgentID": "11ee0040-05c1-86a0-abb3-0242ac110002",
            "Agent": "abdul rauf",
            "Channels": [
                {
                    "Channel": null,
                    "AvgScore": null
                }
            ],
            "TeamAvgScore": 6.12
        },
        {
            "TeamID": "c0ef6aef-0f35-11ed-b815-064e4e02d9cf",
            "Team": "DefaultTeam",
            "AgentID": "11efae65-25b5-b510-9fd3-0242ac110005",
            "Agent": "AgentTest10 CVACD",
            "Channels": [
                {
                    "Channel": "CHAT",
                    "AvgScore": 5.0
                }
            ],
            "TeamAvgScore": 6.12
        },
        {
            "TeamID": "c0ef6aef-0f35-11ed-b815-064e4e02d9cf",
            "Team": "DefaultTeam",
            "AgentID": "11ee1604-50a4-01f0-938d-0242ac110005",
            "Agent": "DanielCurrent1 AgentActive1",
            "Channels": [
                {
                    "Channel": null,
                    "AvgScore": null
                }
            ],
            "TeamAvgScore": 6.12
        },
        {
            "TeamID": "c0ef6aef-0f35-11ed-b815-064e4e02d9cf",
            "Team": "DefaultTeam",
            "AgentID": "11eefc28-58ba-4d80-99f8-0242ac110004",
            "Agent": "HistoricalAgent07 CVACD",
            "Channels": [
                {
                    "Channel": "CHAT",
                    "AvgScore": 1.0
                }
            ],
            "TeamAvgScore": 6.12
        },
        {
            "TeamID": "c0ef6aef-0f35-11ed-b815-064e4e02d9cf",
            "Team": "DefaultTeam",
            "AgentID": "11ed7aa1-45cc-dad0-b770-0242ac110003",
            "Agent": "Ram Agent1",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 5.5
                }
            ],
            "TeamAvgScore": 6.12
        },
        {
            "TeamID": "c0ef6aef-0f35-11ed-b815-064e4e02d9cf",
            "Team": "DefaultTeam",
            "AgentID": "11eefd0a-f05f-6cf0-919b-0242ac110004",
            "Agent": "RealTimeAgent09 CVACD",
            "Channels": [
                {
                    "Channel": "CHAT",
                    "AvgScore": 13.0
                }
            ],
            "TeamAvgScore": 6.12
        },
        {
            "TeamID": "39f1431d-b6d3-45c7-bcc1-570f7453721e",
            "Team": "NRTDataGeneratorTeam",
            "AgentID": "11efbd7c-a033-abf0-a68e-0242ac110004",
            "Agent": "user12 nrtdg",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 13.5
                }
            ],
            "TeamAvgScore": 13.5
        },
        {
            "TeamID": "e7fa8510-c8d6-4a13-8fdf-41736c15a224",
            "Team": "QM Team",
            "AgentID": "11ed75fa-a8a8-4ff0-948d-0242ac110002",
            "Agent": "Rohit Agent",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 0.33
                }
            ],
            "TeamAvgScore": 0.33
        },
        {
            "TeamID": "6a1c5e18-f5d9-40c7-8153-e667f0befff7",
            "Team": "RI_Team",
            "AgentID": "11ed84f1-3154-f6f0-a66d-0242ac110004",
            "Agent": "Ram Admin1",
            "Channels": [
                {
                    "Channel": null,
                    "AvgScore": 5.0
                },
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 7.14
                },
                {
                    "Channel": "EMAIL",
                    "AvgScore": 8.0
                },
                {
                    "Channel": "CHAT",
                    "AvgScore": 2.0
                }
            ],
            "TeamAvgScore": 3.78
        },
        {
            "TeamID": "b6369dd0-4d0e-4ecc-bf7f-16a03439e538",
            "Team": "RK Agent team",
            "AgentID": "11edb971-a232-e1c0-9d71-0242ac110005",
            "Agent": "Rohit Agent1",
            "Channels": [
                {
                    "Channel": null,
                    "AvgScore": 2.0
                },
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 1.38
                }
            ],
            "TeamAvgScore": 1.69
        },
        {
            "TeamID": "95d91ad4-cd8c-4be0-87d3-6c51ae5806d7",
            "Team": "Rohit's  team",
            "AgentID": "11edb971-b1c7-1250-acf9-0242ac110005",
            "Agent": "Rohit Agent2",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 0.5
                }
            ],
            "TeamAvgScore": 0.5
        },
        {
            "TeamID": "30cde3c6-e9c1-45e6-8871-38723a1fa87b",
            "Team": "SN_TEAM",
            "AgentID": "11ee9fec-c788-97a0-a37c-0242ac110002",
            "Agent": "Suprith Agent",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 11.25
                },
                {
                    "Channel": null,
                    "AvgScore": 9.5
                }
            ],
            "TeamAvgScore": 7.92
        },
        {
            "TeamID": "30cde3c6-e9c1-45e6-8871-38723a1fa87b",
            "Team": "SN_TEAM",
            "AgentID": "11edeaea-f7de-6ef0-852f-0242ac110002",
            "Agent": "Suprith Narayana",
            "Channels": [
                {
                    "Channel": "PHONE_CALL",
                    "AvgScore": 3.0
                }
            ],
            "TeamAvgScore": 7.92
        }
    ]
}